import {View} from 'react-native';
import {Props} from './model';
import * as React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {Text} from '../../../../shared/components/text';

export default ({title, children}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {},
    text: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5,
          marginBottom: 18,
        },
        {...theme.fonts.action, marginBottom: 16},
      ),
    },
  }));
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{title}</Text>
      {children}
    </View>
  );
};
